module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","period":"Period","currency":"Currency","enabled":"Enabled","valueDate":"Value date"},"et":{"name":"Name","period":"Period","currency":"Currency","enabled":"Enabled","valueDate":"Value date"},"ru":{"name":"Name","period":"Period","currency":"Currency","enabled":"Enabled","valueDate":"Value date"}}')
  delete Component.options._Ctor
}
